import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";

const DeleteCard = ({ close,deleteMsg }) => {
  return (
    <div className="flex flex-col justify-between bg-white px-4 pt-4 pb-2 gap-y-3 min-w-[378px] h-[150px]">
      <h1 className="text-xl font-semibold text-[#475569 ]">Delete message?</h1>
      <p className="text-sm font-medium text-[#76767C] font-manrope">Are you sure you want to delete the message </p>
      <div className="flex justify-between gap-x-2 py-2">
        <PrimaryButton title="Delete " handler={() => deleteMsg()} css="bg-[#FF3E46] text-white !py-1 rounded-md !text-xs font-normal !px-7 w-full" />
        <SecondaryButton title="Cancel" handler={() => close()} css=" !py-1 !text-xs font-normal !px-7 w-full" />
      </div>
    </div>
  );
};

export default DeleteCard;
